import http from 'hub-http/clients/apiClient';
export const fetchThirdPartyApps = () => {
  return http.get('/share-with-third-party/v1/integrations');
};